export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9029.69a8d715.jpg";